import classnames from 'classnames';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';

var _excluded = ["styles"];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var CloseIcon = (function (_ref) {
  _ref.styles;
    var props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "1 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "23",
    r: "20",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#676F76",
    strokeWidth: "3",
    d: "M15.894 14.439L32.56 31.106M32.106 14.44L15.44 31.105"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: "0",
    y: "0",
    width: "48",
    height: "48",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: "1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }))));
});

var ANIMATION_DELAY = 50;
var DEFAULT_MAX_WIDTH = "37.5rem";
var DEFAULT_POSITION = "right";
var Panel = function Panel(_a) {
  var _b = _a.onOverlayClick,
    onOverlayClick = _b === void 0 ? function () {} : _b,
    _c = _a.onCloseButtonClick,
    onCloseButtonClick = _c === void 0 ? function () {} : _c,
    _d = _a.onAnimationEnd,
    onAnimationEnd = _d === void 0 ? function () {} : _d,
    isOpen = _a.isOpen,
    _e = _a.hasOverlay,
    hasOverlay = _e === void 0 ? true : _e,
    _f = _a.isCloseButtonVisible,
    isCloseButtonVisible = _f === void 0 ? true : _f,
    _g = _a.maxWidth,
    maxWidth = _g === void 0 ? DEFAULT_MAX_WIDTH : _g,
    _h = _a.position,
    position = _h === void 0 ? DEFAULT_POSITION : _h,
    children = _a.children;
  var _j = useState(false),
    isVisible = _j[0],
    setIsVisible = _j[1];
  var _k = useState(false),
    isOverlayVisible = _k[0],
    setIsOverlayVisible = _k[1];
  var _l = useState(0),
    panelMaxWidth = _l[0],
    setPanelMaxWidth = _l[1];
  var _m = useState(false),
    isFullyVisible = _m[0],
    setFullyVisible = _m[1];
  useEffect(function () {
    if (isOpen) {
      setIsVisible(true);
      setTimeout(function () {
        setPanelMaxWidth(maxWidth);
        setIsOverlayVisible(true);
      }, ANIMATION_DELAY);
    } else {
      setPanelMaxWidth(0);
      setIsOverlayVisible(false);
    }
  }, [setIsVisible, isOpen, maxWidth]);
  useEffect(function () {
    setFullyVisible(false);
  }, [isOpen]);
  var containerClasses = classnames("flex", "fixed", "z-100", "h-full", "inset-0", "auto-qa-panel", {
    "justify-end": position === "right",
    "flex-row-reverse": hasOverlay && position === "left"
  }, {
    "left-auto": position === "right" && (!hasOverlay || !isVisible),
    "right-auto": position === "left" && (!hasOverlay || !isVisible)
  }, {
    "auto-qa-panel-fully-visible": isFullyVisible
  }, {
    "w-full": isVisible
  });
  var overlayClasses = classnames("bg-darkest", "transition-opacity", "duration-300", "sm:flex-grow", {
    "opacity-0": !isOverlayVisible,
    "opacity-50": isOverlayVisible
  }, "auto-qa-panel-overlay", {
    hidden: !isVisible
  });
  var panelClasses = classnames("bg-lightest", "transition-[max-width]", "duration-300", "flex", {
    "ease-in": isOpen,
    "ease-out": !isOpen,
    "border-l": !hasOverlay && position === "right",
    "border-r": !hasOverlay && position === "left",
    "border-muted": !hasOverlay
  });
  var contentClasses = classnames("relative", {
    "float-right": position === "left"
  }, "flex", "flex-col", "flex-grow");
  var buttonClasses = classnames({
    hidden: !isVisible,
    "opacity-0": !isOverlayVisible,
    "opacity-100": isOverlayVisible
  }, "transition-opacity", "auto-qa-panel-close", "cursor-pointer", "m-xs", "sm:m-sm");
  return /*#__PURE__*/React.createElement("div", {
    className: containerClasses,
    style: {
      maxWidth: hasOverlay ? undefined : panelMaxWidth,
      overflow: "hidden"
    }
  }, hasOverlay && /*#__PURE__*/React.createElement("div", {
    onClick: onOverlayClick,
    className: overlayClasses,
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("div", {
    className: panelClasses,
    style: {
      maxWidth: panelMaxWidth,
      flexGrow: 2
    },
    onTransitionEnd: function onTransitionEnd() {
      !isOpen && setIsVisible(false);
      isOpen && setFullyVisible(true);
      onAnimationEnd();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: contentClasses,
    style: {
      maxWidth: maxWidth
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "self-end"
  }, isCloseButtonVisible && /*#__PURE__*/React.createElement("button", {
    onClick: onCloseButtonClick,
    "aria-label": "close",
    className: buttonClasses
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    style: {
      left: "-3rem",
      height: "2.5rem",
      width: "2.5rem"
    }
  }))), /*#__PURE__*/React.createElement("div", null, children))));
};
Panel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onOverlayClick: PropTypes.func,
  onCloseButtonClick: PropTypes.func,
  isCloseButtonVisible: PropTypes.bool,
  maxWidth: PropTypes.string,
  children: PropTypes.node,
  hasOverlay: PropTypes.bool,
  onAnimationEnd: PropTypes.func,
  position: PropTypes.oneOf(["left", "right"])
};

export { Panel };
//# sourceMappingURL=index.es.js.map
